import { render, staticRenderFns } from "./BranchRoleFloatBtns.vue?vue&type=template&id=1f900356&"
import script from "./BranchRoleFloatBtns.vue?vue&type=script&lang=js&"
export * from "./BranchRoleFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports